import React from "react";
import HeaderWithSearch from "./HeaderWithSearch";
import ImageWithFallback from "./ImageWithFallback";

function MangoPuddingWeikfield() {
  return (
    <>
      <HeaderWithSearch />
      <main style={{
        minHeight: "100vh",
        width: "100%",
        background: "linear-gradient(180deg, #e3f0fc 0%, #fafdff 100%)",
        padding: 0,
        margin: 0
      }}>
        <section className="recipe-hero-anim" style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          minHeight: "40vh",
          padding: "60px 0 20px 0"
        }}>
          <h1 className="recipe-title-anim" style={{ fontSize: "3rem", fontWeight: "bold", marginBottom: 12 }}>Mango Pudding Custard</h1>
          <p style={{ fontSize: "1.3rem", color: "#333", marginBottom: 16 }}>Smooth, golden mango pudding made with Weikfield custard mix — a quick sweet snack.</p>
          <span className="season-badge season-summer">☀️ Best in Summer</span>
          <ImageWithFallback src="/mango_pudding_weikfield.png" alt="Dome of glossy mango pudding in a small metal bowl with a spoon" className="recipe-image-anim" style={{ width: 340, borderRadius: 24, boxShadow: "0 4px 32px rgba(0,0,0,0.10)", marginBottom: 24, marginTop: 16 }} />
        </section>
        <section className="recipe-columns-anim" style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
          alignItems: "flex-start",
          gap: 48,
          padding: "20px 0 0 0",
          maxWidth: 1200,
          margin: "0 auto"
        }}>
          <div style={{ flex: 1, minWidth: 320 }}>
            <h2 style={{ fontSize: "2rem", fontWeight: 600, marginBottom: 16, color: "#1a3a5d" }}>Ingredients</h2>
            <ul className="ingredient-list" style={{ fontSize: "1.1rem", color: "#444", lineHeight: 1.7, marginLeft: 18 }}>
              <li>Weikfield Mango Pudding Custard mix (as needed for your serving size)</li>
              <li>Milk, per package directions</li>
              <li>Sugar, if the recipe on the pack calls for it</li>
              <li>Fresh mango cubes or a drizzle of mango purée (optional, for topping)</li>
              <li>Fresh mint leaf (optional garnish)</li>
            </ul>
          </div>
          <div style={{ flex: 2, minWidth: 320 }}>
            <h2 style={{ fontSize: "2rem", fontWeight: 600, marginBottom: 16, color: "#1a3a5d" }}>Instructions</h2>
            <ol className="instructions-list" style={{ fontSize: "1.1rem", color: "#444", lineHeight: 1.7, marginLeft: 18 }}>
              <li>Read the Weikfield Mango Pudding Custard pack and measure the mix, milk, and any sugar exactly as instructed.</li>
              <li>Whisk the custard powder with a little cold milk until smooth, then heat with the rest of the milk (or follow the boil-and-stir method on the pack) until thick and glossy.</li>
              <li>Pour into small bowls or ramekins. Cool slightly, then refrigerate until set and chilled.</li>
              <li>Unmold or serve in the bowl. Top with fresh mango, a little purée, or mint if you like. Enjoy cold as a snack or light dessert.</li>
            </ol>
          </div>
        </section>
        <section style={{ maxWidth: 1200, margin: "0 auto", padding: "24px 24px 60px 24px", display: "flex", gap: 32, flexWrap: "wrap" }}>
          <div className="chef-tips-box" style={{ flex: 1, minWidth: 300, background: "#f8f9fa", padding: 20, borderRadius: 12 }}>
            <h3 style={{ fontSize: "1.3rem", fontWeight: 600, marginBottom: 12 }}>
              <span className="tip-icon" role="img" aria-label="chef">👨‍🍳</span> Chef's Tips
            </h3>
            <ul style={{ paddingLeft: 20 }}>
              <li>Whisk the powder into cold milk first — adding it straight to hot milk causes lumps.</li>
              <li>Stir constantly while heating so the custard doesn't catch and scorch on the bottom.</li>
              <li>Lightly wet the ramekins before pouring so the set pudding unmolds cleanly.</li>
              <li>Chill for at least 2 hours for the firmest, cleanest slice or scoop.</li>
            </ul>
          </div>
          <div className="health-benefits-box" style={{ flex: 1, minWidth: 300, background: "#eef9f0", padding: 20, borderRadius: 12 }}>
            <h3 style={{ fontSize: "1.3rem", fontWeight: 600, marginBottom: 12 }}>
              <span className="tip-icon" role="img" aria-label="health">🌿</span> Health Benefits
            </h3>
            <ul style={{ paddingLeft: 20 }}>
              <li>Milk-based custard provides calcium and protein alongside the sweetness.</li>
              <li>Topping with fresh mango adds vitamin A and C instead of relying on sugar alone.</li>
              <li>A small, portioned dessert that's easier to enjoy in moderation than a large slice of cake.</li>
              <li>A cool, light treat that's gentle on the stomach after a spicy meal.</li>
            </ul>
          </div>
        </section>
      </main>
    </>
  );
}

export default MangoPuddingWeikfield;
